import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Ink from 'react-ink';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { bindActionCreators } from 'redux';
import { CSSTransitionGroup } from 'react-transition-group';

import * as AgentActions from './AgentActions';
import * as AppActions from '../app/AppActions';
import ReactGA from 'react-ga';
import './Style';

export class AgentFullscreenContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sender: {
                name: '',
                nameHasError: false,
                email: '',
                emailHasError: false,
                comments: ''
            },
            emailRegex: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            agentType: props.pathname.indexOf('contactagent') >= 0 ? 'agent' : 'colister',
            toastId: null,
            windowWidth : window.innerWidth
        }

        this.inputChange = this.inputChange.bind(this);
        this.contactAgentClick = this.contactAgentClick.bind(this);
        this.contactCloseOnClick = this.contactCloseOnClick.bind(this);
        this.onResize = this.onResize.bind(this);
    }

    componentDidMount = () => {
        window.addEventListener('resize', this.onResize, false);
        // ReactGA.pageview(window.location.pathname);
        window.scrollTo(0, 0);
    }

    componentWillUnmount = () => {
        window.removeEventListener('resize', this.onResize, false);
    }

    onResize() {
        this.setState({windowWidth : window.innerWidth});
    }

    componentWillReceiveProps(nextProps) {
        const pathname = nextProps.pathname;

        if (pathname.indexOf('contactagent') >= 0) {
            this.setState({
                agentType: 'agent'
            });
        }

        if (pathname.indexOf('contactagent') >= 0) {
            this.setState({
                agentType: 'colister'
            });
        }
    }

    contactAgentClick() {
        const { sender, emailRegex, toastId, agentType } = this.state;

        let nameHasError = false;
        let emailHasError = false;

        if (!sender.name.trim().length) {
            nameHasError = true;
        }

        if (!sender.email.trim().length || !emailRegex.test(sender.email)) {
            emailHasError = true;
        }

        this.setState({
            ...this.state,
            sender: {
                ...sender,
                nameHasError,
                emailHasError
            }
        }, () => {
            if (!nameHasError && !emailHasError) {
                grecaptcha.ready(() => {
                    const sitekey = this.props.reCaptcha_key; // Google reCaptcha key from Tour data (see screenshot above)
                    grecaptcha.execute(sitekey, {action: 'homepage'}).then((token) => {
                            this.props.contactAgent(this.state.sender, this.props.agentType, token);
                            if (!toast.isActive(toastId)) {
                                this.setState({
                                    toast: toast.success('Mail has been sent.')
                                });
                            }
                            this.setState({
                                ...this.state,
                                sender: {
                                    ...this.state.sender,
                                    name: '',
                                    email: '',
                                    comments: ''
                                }
                            });
                        });
                    });
                }
        });
    }

    inputChange(e) {
        this.setState({
            ...this.state,
            sender: {
                ...this.state.sender,
                nameHasError: false,
                emailHasError: false,
                [e.target.name]: e.target.value
            }
        });
    }

    contactCloseOnClick() {
        this.props.appActions.redirectToHome();
    }

    phoneClick() {
        // ReactGA.event({
        //     category: 'external links',
        //     action: 'agent phone'
        // });
    }

    emailClick() {
        // ReactGA.event({
        //     category: 'external links',
        //     action: 'agent email'
        // });
    }

    websiteClick() {
        // ReactGA.event({
        //     category: 'external links',
        //     action: 'agent website'
        // });
    }

    render() {
        const {
            agentInfo,
            colisterInfo
        } = this.props;
        const { agentType, sender } = this.state;

        let agentInfoObj = {};
        if (agentType === 'agent') {
            agentInfoObj = agentInfo;
        }

        if (agentType === 'colister') {
            agentInfoObj = colisterInfo;
        }

        const agentPhoneItem = (title, value) => {
            if (value) {
                let link = value.indexOf('+') === -1 ? `tel:+1${value}` : `tel:${value}`;
                let label = this.state.windowWidth >= 768 ? `${title}:` : `${title[0]}:`;
                return (
                    <div className="agent-contact-item">
                        <i className="fa fa-phone"></i>
                        {label}
                        <a className='agent-phone' href={link} onClick={this.phoneClick}>{value}</a>
                    </div>
                )
            } else {
                return null;
            }
        }

        const logoBlock = agentInfoObj.logo
            ? (
                <div className="agent-logo">
                    <img src={agentInfoObj.logo} alt="agent logo"/>
                </div>
            )
            : null;
        const nameBlock = agentInfoObj.name
            ? (
                <div className="agent-name">
                    <h2>{agentInfoObj.name}</h2>
                </div>
            )
            : null;
        const directPhoneBlock = agentPhoneItem('direct', agentInfoObj.phone);
        const bussinessPhoneBlock = agentPhoneItem('office', agentInfoObj.businessPhone);
        const cellPhoneBlock = agentPhoneItem('mobile', agentInfoObj.mobilePhone);
        const faxLink = agentInfoObj.fax.indexOf('+') === -1 ? `tel:+1${agentInfoObj.fax}` : `tel:${agentInfoObj.fax}`;
        const faxBlock = agentInfoObj.fax
            ? (
                <div className="agent-contact-item">
                    <i className="fa fa-fax"></i>
                    <a className='agent-fax' href={faxLink} onClick={this.phoneClick}>{agentInfoObj.fax}</a>
                </div>
            )
            : null;
        const emailBlock = agentInfoObj.email
            ? (
                <div className='agent-contact-item'>
                <i className="fa fa-envelope"></i>
                    <span>
                        <a href={`mailto:${agentInfoObj.email}`} onClick={this.emailClick}>
                            {agentInfoObj.email}
                        </a>
                    </span>
                </div>
            )
            : null;

        const websiteBlock = agentInfoObj.website
            ? (
                <div className="agent-contact-item">
                <i className="fa fa-external-link-square"></i>
                    <span>
                        <a href={`${agentInfoObj.orig_website}`} target='_blank' onClick={this.websiteClick}>
                            {agentInfoObj.website}
                        </a>
                    </span>
                </div>
            )
            : null;

        return (
            <div>
                <CSSTransitionGroup
                    transitionName="opacityAnim"
                    transitionAppear={true}
                    transitionAppearTimeout={500}
                    transitionEnter={false}
                    transitionLeave={false}>
                    <div className="agent-fullscreen" key="contact">
                        <div className="agent-fullscreen-header">
                            <h2>
                                contact agent
                            </h2>
                            <div className="agent-fullscreen-close">
                                <button className="btn" onClick={this.contactCloseOnClick}>
                                    <i className="fa fa-times-circle"></i>
                                    <Ink />
                                </button>
                            </div>
                        </div>
                        <div className="agent-fullscreen-body">
                            <div className="agent-fullscreen-info">
                                {logoBlock}
                                {nameBlock}
                                {directPhoneBlock}
                                {bussinessPhoneBlock}
                                {cellPhoneBlock}
                                {faxBlock}
                                {emailBlock}
                                {websiteBlock}
                            </div>
                            <div className="agent-fullscreen-form">
                                <input
                                    type="text"
                                    className={
                                        sender.nameHasError
                                            ? 'agent-form-name form-control has-error'
                                            : 'agent-form-name form-control'
                                        }
                                    name='name'
                                    value={sender.name}
                                    onChange={this.inputChange}
                                    placeholder='NAME'/>
                                <input
                                    type="text"
                                    className={
                                        sender.emailHasError
                                        ? 'agent-form-email form-control has-error'
                                        : 'agent-form-email form-control'
                                    }
                                    name='email'
                                    value={sender.email}
                                    onChange={this.inputChange}
                                    placeholder='EMAIL'/>
                                <textarea
                                    className="form-control"
                                    name='comments'
                                    value={sender.comments}
                                    onChange={this.inputChange}
                                    placeholder="COMMENTS">
                                </textarea>
                                <p style={{ fontSize: 9 }}>
                            This site is protected by reCAPTCHA and the Google <a style={{ color: '#2d9cdb' }} href="https://policies.google.com/privacy">Privacy Policy</a> and
    <a style={{ color: '#2d9cdb' }} href="https://policies.google.com/terms"> Terms of Service</a> apply.
                        </p>
                                <button className="btn" onClick={this.contactAgentClick}>
                                    <Ink />
                                    contact agent
                                </button>
                            </div>
                        </div>
                    </div>
                    </CSSTransitionGroup>
            </div>
        )
    }
}

AgentFullscreenContainer.propTypes = {
    agentInfo: PropTypes.object.isRequired,
    colisterInfo: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
    agentInfo: state.agent.agentInfo,
    colisterInfo: state.agent.colisterInfo,
    pathname: state.routing.location.pathname,
    reCaptcha_key: state.app.reCaptcha_key
});

const mapDispatchToProps = (dispatch) => ({
    agentActions: bindActionCreators(AgentActions, dispatch),
    appActions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AgentFullscreenContainer)
